export const styles = () => ({
  content: {
    padding: 20,
  },
});



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/styles.ts